module.exports = __webpack_public_path__ + "static/share-session-13c5d65a3e5bcb16872cb4d8bb3c7ab4.png";